import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {
    ControlService,
    IconService,
    MenuService,
    ParametersService,
    SubtitlesService,
    ViewsService,
    ZonesService,
} from "../core";
import {MenuElement} from "../models";

@Component({
    selector: 'submenu',
    templateUrl: './submenu.component.html',
    styleUrls: ['./submenu.component.scss']
})
export class SubmenuComponent implements OnInit {
    private allBreadcrumbs: MenuElement[] = [];

    constructor(
        private control: ControlService,
        private icon: IconService,
        private location: Location,
        public menu: MenuService,
        public parameters: ParametersService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
        private zones: ZonesService,
    ) {
    }

    ngOnInit() {
        this.views.setSubMenuWindowValues();
    }

    getWiki(element: MenuElement): string {
        return this.subtitles.setWiki(element.wikiTxtId);
    }

    clickOutsideWiki() {
        this.menu.showWiki(0);
    }

    get wikiActiveInfoClass() {
        return {'wiki-info-wrapper--active': this.menu.wikiInfo.length > 0 && !this.menu.showDropdownMenu}
    }

    setDay(element: number): string {
        return element >= 0 ? this.menu.setDayName(element) : '';
    }

    setIcon(element: number): string {
        return this.icon.setIcon(element);
    }

    subtitle(element: number) {
        return element ? this.subtitles.setSubtitle(element) : '';
    }

    getMainMenu(): MenuElement[] {
        const url = this.location.path();

        switch (true) {
            case url.indexOf('fitters_menu') >= 0:
                return 'MI' in this.menu.mainMenu ? this.menu.mainMenu.MI : [];
            case url.indexOf('service_menu') >= 0:
                return 'MS' in this.menu.mainMenu ? this.menu.mainMenu.MS : [];
            case url.indexOf('manufacturer_menu') >= 0:
                return 'MP' in this.menu.mainMenu ? this.menu.mainMenu.MP : [];
            case url.indexOf('menu') >= 0:
                return 'MU' in this.menu.mainMenu ? this.menu.mainMenu.MU : [];
            default:
                return [];
        }
    }

    getBreadcrumbs(element: MenuElement | 0, windowWidth?: number): MenuElement[] {
        if (windowWidth <= 900) return this.menu.allBreadcrumbs;
        this.allBreadcrumbs = this.menu.getBreadcrumbs(element);
        return this.allBreadcrumbs;
    }
}
